export default {
  FETCH_QUESTIONS_REQUEST: 'FETCH_QUESTIONS_REQUEST',
  FETCH_QUESTIONS_SUCCESS: 'FETCH_QUESTIONS_SUCCESS',
  FETCH_MODAL_QUESTIONS_SUCCESS: 'FETCH_MODAL_QUESTIONS_SUCCESS',
  FETCH_QUESTIONS_ERROR: 'FETCH_QUESTIONS_ERROR',
  FETCH_SITE_REQUEST: 'FETCH_SITE_REQUEST',
  FETCH_SITE_SUCCESS: 'FETCH_SITE_SUCCESS',
  FETCH_SITE_ERROR: 'FETCH_SITE_ERROR',
  FETCH_SITE_NOT_FOUND: 'FETCH_SITE_NOT_FOUND',
  FETCH_SITE_HAS_ACTIVE_ABN_REQUEST: 'FETCH_SITE_HAS_ACTIVE_ABN_REQUEST',
  FETCH_SITE_HAS_ACTIVE_ABN_SUCCESS: 'FETCH_SITE_HAS_ACTIVE_ABN_SUCCESS',
  FETCH_SITE_HAS_ACTIVE_ABN_ERROR: 'FETCH_SITE_HAS_ACTIVE_ABN_ERROR',
  FETCH_SITE_HAS_ACTIVE_ABN_NOT_FOUND: 'FETCH_SITE_HAS_ACTIVE_ABN_NOT_FOUND',
  FETCH_FEED_REQUEST: 'FETCH_FEED_REQUEST',
  FETCH_FEED_SUCCESS: 'FETCH_FEED_SUCCESS',
  FETCH_FEED_ERROR: 'FETCH_FEED_ERROR',
  FETCH_FEED_NOT_FOUND: 'FETCH_FEED_NOT_FOUND',
  CLEAR_FEEDS: 'CLEAR_FEEDS',
  POST_JOB_SUCCESS: 'POST_JOB_SUCCESS',
  JOB_CONNECT_MORE_REQUEST: 'JOB_CONNECT_MORE_REQUEST',
  JOB_CONNECT_MORE_SUCCESS: 'JOB_CONNECT_MORE_SUCCESS',
  JOB_CONNECT_MORE_ERROR: 'JOB_CONNECT_MORE_ERROR',

  USER_SET_ID: 'USER_SET_ID',
  USER_LOGGED_IN: 'USER_LOGGED_IN',
  USER_LOGIN_ERROR: 'USER_LOGIN_ERROR',
  USER_SIGNUP: 'USER_SIGNUP',
  USER_SIGNUP_ERROR_INFO: 'USER_SIGNUP_ERROR_INFO',
  USER_SIGNUP_ERROR: 'USER_SIGNUP_ERROR',
  USER_SIGNUP_SUCCESS: 'USER_SIGNUP_SUCCESS',
  USER_SIGNUP_MESSAGE: 'USER_SIGNUP_MESSAGE',
  USER_LOGIN_CHECK_SUCCESS: 'USER_LOGIN_CHECK_SUCCESS',
  USER_LOGIN_CHECK_UNKNOWN: 'USER_LOGIN_CHECK_UNKNOWN',

  SET_PASSWORD_SUCCESS: 'SET_PASSWORD_SUCCESS',
  SET_PASSWORD_ERROR: 'SET_PASSWORD_ERROR',
  FACEBOOK_CONNECT_SUCCESS: 'FACEBOOK_CONNECT_SUCCESS',
  USER_SET_JWT: 'USER_SET_JWT',
  LOAD_BUN_CATEGORY: 'LOAD_BUN_CATEGORY',
  FETCH_JOB_REQUEST: 'FETCH_JOB_REQUEST',
  FETCH_JOB_ERROR: 'FETCH_JOB_ERROR',
  FETCH_JOB_SUCCESS: 'FETCH_JOB_SUCCESS',
  FETCH_JOB_NOT_FOUND: 'FETCH_JOB_NOT_FOUND',
  FETCH_CATEGORY_SUCCESS: 'FETCH_CATEGORY_SUCCESS',
  FETCH_CATEGORY_ERROR: 'FETCH_CATEGORY_ERROR',

  FETCH_CATEGORY_LIST_SUCCESS: 'FETCH_CATEGORY_LIST_SUCCESS',
  FETCH_CATEGORY_LIST_ERROR: 'FETCH_CATEGORY_LIST_ERROR',
  FETCH_CATEGORY_FROM_KEY_SUCCESS: 'FETCH_CATEGORY_FROM_KEY_SUCCESS',
  FETCH_CATEGORY_FROM_KEY_ERROR: 'FETCH_CATEGORY_FROM_KEY_ERROR',
  FETCH_CATEGORY_SUGGESTIONS_SUCCESS: 'FETCH_CATEGORY_SUGGESTIONS_SUCCESS',
  FETCH_CATEGORY_SUGGESTIONS_ERROR: 'FETCH_CATEGORY_SUGGESTIONS_ERROR',
  FETCH_CATEGORIES_SUCCESS: 'FETCH_CATEGORIES_SUCCESS',
  FETCH_CATEGORIES_ERROR: 'FETCH_CATEGORIES_ERROR',
  FETCH_LOCATION_SUCCESS: 'FETCH_LOCATION_SUCCESS',
  FETCH_LOCATION_ERROR: 'FETCH_LOCATION_ERROR',
  FETCH_LOCATION_TO_POSTCODE_SUCCESS: 'FETCH_LOCATION_TO_POSTCODE_SUCCESS',
  FETCH_LOCATION_TO_POSTCODE_ERROR: 'FETCH_LOCATION_TO_POSTCODE_ERROR',
  MODAL_HIPROJECTS_STATUS: 'MODAL_HIPROJECTS_STATUS',
  MODAL_CLOSEJOB_STATUS: 'MODAL_CLOSEJOB_STATUS',
  MODAL_JOBDETAILS_STATUS: 'MODAL_JOBDETAILS_STATUS',
  UPDATE_MODAL_ACCOUNT: 'UPDATE_MODAL_ACCOUNT',
  UPDATE_MODAL_FEEDBACK_MESSAGE: 'UPDATE_MODAL_FEEDBACK_MESSAGE',
  UPDATE_MODAL_FEEDBACK_QUOTE: 'UPDATE_MODAL_FEEDBACK_QUOTE',
  UPDATE_MODAL_FEEDBACK_REVIEW: 'UPDATE_MODAL_FEEDBACK_REVIEW',
  HARD_REDIRECT_TO: 'HARD_REDIRECT_TO',
  CLOSE_JOB_SUCCESS: 'CLOSE_JOB_SUCCESS',
  FETCH_JOB_INVITATIONS_REQUEST: 'FETCH_JOB_INVITATIONS_REQUEST',
  FETCH_JOB_INVITATIONS_SUCCESS: 'FETCH_JOB_INVITATIONS_SUCCESS',
  FETCH_JOB_INVITATIONS_ERROR: 'FETCH_JOB_INVITATIONS_ERROR',
  FETCH_JOB_CONNECTIONS_REQUEST: 'FETCH_JOB_CONNECTIONS_REQUEST',
  FETCH_JOB_CONNECTIONS_SUCCESS: 'FETCH_JOB_CONNECTIONS_SUCCESS',
  FETCH_JOB_CONNECTIONS_ERROR: 'FETCH_JOB_CONNECTIONS_ERROR',
  FETCH_JOB_STATUS_SUCCESS: 'FETCH_JOB_STATUS_SUCCESS',
  FETCH_JOB_STATUS_ERROR: 'FETCH_JOB_STATUS_ERROR',
  MARK_CHECKPOINT: 'MARK_CHECKPOINT',
  UNMARK_CHECKPOINT: 'UNMARK_CHECKPOINT',
  SET_IS_FIRST_VIEW: 'SET_IS_FIRST_VIEW',
  FETCH_RECOMMENDATIONS_SUCCESS: 'FETCH_RECOMMENDATIONS_SUCCESS',
  FETCH_RECOMMENDATIONS_ERROR: 'FETCH_RECOMMENDATIONS_ERROR',
  FETCH_RECOMMENDATIONS_REQUEST: 'FETCH_RECOMMENDATIONS_REQUEST',
  FETCH_RECOMMENDATIONS_NOT_FOUND: 'FETCH_RECOMMENDATIONS_NOT_FOUND',
  CONNECTION_ADD_WAITLIST_REQUEST: 'CONNECTION_ADD_WAITLIST_REQUEST',
  CONNECTION_ADD_WAITLIST_SUCCESS: 'CONNECTION_ADD_WAITLIST_SUCCESS',
  CONNECTION_ADD_WAITLIST_ERROR: 'CONNECTION_ADD_WAITLIST_ERROR',
  UPDATE_CONNECTION: 'UPDATE_CONNECTION',
  FETCH_QUESTIONS_NOT_FOUND: 'FETCH_QUESTIONS_NOT_FOUND',
  FETCH_THREAD_REQUEST: 'FETCH_THREAD_REQUEST',
  FETCH_THREAD_SUCCESS: 'FETCH_THREAD_SUCCESS',
  FETCH_THREAD_ERROR: 'FETCH_THREAD_ERROR',
  FETCH_CONTACTS_REQUEST: 'FETCH_CONTACTS_REQUEST',
  FETCH_CONTACTS_SUCCESS: 'FETCH_CONTACTS_SUCCESS',
  FETCH_CONTACTS_ERROR: 'FETCH_CONTACTS_ERROR',
  FETCH_FEEDBACK_REQUEST: 'FETCH_FEEDBACK_REQUEST',
  FETCH_FEEDBACK_SUCCESS: 'FETCH_FEEDBACK_SUCCESS',
  FETCH_FEEDBACK_ERROR: 'FETCH_FEEDBACK_ERROR',
  UPDATE_FEEDBACK_ANSWER: 'UPDATE_FEEDBACK_ANSWER',
  REMOVE_FEEDBACK_ANSWER: 'REMOVE_FEEDBACK_ANSWER',
  FETCH_VOUCHER_ACTIVATE_SUCCESS: 'FETCH_VOUCHER_ACTIVATE_SUCCESS',
  CHECK_ACTIVATE_ERROR: 'CHECK_ACTIVATE_ERROR',
  UPDATE_THREAD: 'UPDATE_THREAD',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  FETCH_VOUCHER_SUCCESS: 'FETCH_VOUCHER_SUCCESS',
  ADD_VOUCHER_COUPON_REQUEST: 'ADD_VOUCHER_COUPON_REQUEST',
  ADD_VOUCHER_COUPON_SUCCESS: 'ADD_VOUCHER_COUPON_SUCCESS',
  ADD_VOUCHER_COUPON_DONE: 'ADD_VOUCHER_COUPON_DONE',
  ADD_VOUCHER_COUPON_ERROR: 'ADD_VOUCHER_COUPON_ERROR',
  SHAREABLE_CODE_INPUT: 'SHAREABLE_CODE_INPUT',
  SHAREABLE_QUERY: 'SHAREABLE_QUERY',
  SHAREABLE_CODE_INCORRECT: 'SHAREABLE_CODE_INCORRECT',
  SHAREABLE_CODE_MESSAGE: 'SHAREABLE_CODE_MESSAGE',
  FETCH_PAGE_REQUEST: 'FETCH_PAGE_REQUEST',
  FETCH_PAGE_SUCCESS: 'FETCH_PAGE_SUCCESS',
  FETCH_PAGE_ERROR: 'FETCH_PAGE_ERROR',
  FETCH_PAGE_NOT_FOUND: 'FETCH_PAGE_NOT_FOUND',
  FETCH_ADVERTISE_FORM_DATA_SUCCESS: 'FETCH_ADVERTISE_FORM_DATA_SUCCESS',
  FETCH_ADVERTISE_FORM_DATA_ERROR: 'FETCH_ADVERTISE_FORM_DATA_ERROR',
  FETCH_ADVERTISE_INCOMING_LEADS_SUCCESS: 'FETCH_ADVERTISE_INCOMING_LEADS_SUCCESS',
  FETCH_ADVERTISE_INCOMING_LEADS_ERROR: 'FETCH_ADVERTISE_INCOMING_LEADS_ERROR',
  FETCH_ADVERTISE_RECOMMENDATIONS_SUCCESS: 'FETCH_ADVERTISE_RECOMMENDATIONS_SUCCESS',
  FETCH_ADVERTISE_RECOMMENDATIONS_ERROR: 'FETCH_ADVERTISE_RECOMMENDATIONS_ERROR',
  FETCH_ADVERTISE_CATEGORY_LIST_SUCCESS: 'FETCH_ADVERTISE_CATEGORY_LIST_SUCCESS',
  FETCH_ADVERTISE_CATEGORY_LIST_ERROR: 'FETCH_ADVERTISE_CATEGORY_LIST_ERROR',
  FETCH_ADVERTISE_WHERE_LIST_SUCCESS: 'FETCH_ADVERTISE_WHERE_LIST_SUCCESS',
  FETCH_ADVERTISE_WHERE_LIST_ERROR: 'FETCH_ADVERTISE_WHERE_LIST_ERROR',
  FETCH_SITE_JOBS_REQUEST: 'FETCH_SITE_JOBS_REQUEST',
  FETCH_SITE_JOBS_SUCCESS: 'FETCH_SITE_JOBS_SUCCESS',
  FETCH_SITE_JOBS_ERROR: 'FETCH_SITE_JOBS_ERROR',

  // bunning onboarding
  SAVE_BUN_FORM_QUESTIONS_SUCCESS: 'SAVE_BUN_FORM_QUESTIONS_SUCCESS',
  SAVE_BUN_FORM_QUESTIONS__ERROR: 'SAVE_BUN_FORM_QUESTIONS__ERROR',
  FETCH_BUN_FORM_QUESTIONS_REQUEST: 'FETCH_BUN_FORM_QUESTIONS_REQUEST',
  FETCH_BUN_FORM_QUESTIONS_SUCCESS: 'FETCH_BUN_FORM_QUESTIONS_SUCCESS',
  FETCH_BUN_FORM_QUESTIONS_NOT_FOUND: 'FETCH_BUN_FORM_QUESTIONS_NOT_FOUND',
  FETCH_BUN_FORM_QUESTIONS_ERROR: 'FETCH_BUN_FORM_QUESTIONS_ERROR',
  STORE_LOCATION_SUCCESS: 'STORE_LOCATION_SUCCESS',
  FETCH_HOMEPAGE_DATA_SUCCESS: 'FETCH_HOMEPAGE_DATA_SUCCESS',

  // Articles

  SUBMIT_GET_QUOTE_SUCCESS: 'SUBMIT_GET_QUOTE_SUCCESS',
  FETCH_ARTICLE_REQUEST: 'FETCH_ARTICLE_REQUEST',
  FETCH_ARTICLE_SUCCESS: 'FETCH_ARTICLE_SUCCESS',
  FETCH_ARTICLE_ERROR: 'FETCH_ARTICLE_ERROR',
  FETCH_ARTICLE_NOT_FOUND: 'FETCH_ARTICLE_NOT_FOUND',
  FETCH_TOPIC_REQUEST: 'FETCH_TOPIC_REQUEST',
  FETCH_TOPIC_SUCCESS: 'FETCH_TOPIC_SUCCESS',
  FETCH_TOPIC_ERROR: 'FETCH_TOPIC_ERROR',
  FETCH_CATEGORY_REQUEST: 'FETCH_CATEGORY_REQUEST',
  FETCH_ARTICLES_REQUEST: 'FETCH_ARTICLES_REQUEST',
  FETCH_ARTICLES_SUCCESS: 'FETCH_ARTICLES_SUCCESS',
  FETCH_ARTICLES_ERROR: 'FETCH_ARTICLES_ERROR',
  FETCH_LATEST_ARTICLES_REQUEST: 'FETCH_LATEST_ARTICLES_REQUEST',
  FETCH_LATEST_ARTICLES_SUCCESS: 'FETCH_LATEST_ARTICLES_SUCCESS',
  FETCH_LATEST_ARTICLES_ERROR: 'FETCH_LATEST_ARTICLES_ERROR',
  FETCH_LATEST_ARTICLES_NOT_FOUND: 'FETCH_LATEST_ARTICLES_NOT_FOUND',
  FETCH_FEATURED_ARTICLES_REQUEST: 'FETCH_FEATURED_ARTICLES_REQUEST',
  FETCH_FEATURED_ARTICLES_SUCCESS: 'FETCH_FEATURED_ARTICLES_SUCCESS',
  FETCH_FEATURED_ARTICLES_ERROR: 'FETCH_FEATURED_ARTICLES_ERROR',
  FETCH_FEATURED_ARTICLES_NOT_FOUND: 'FETCH_FEATURED_ARTICLES_NOT_FOUND',
  FETCH_STATES_SUCCESS: 'FETCH_STATES_SUCCESS',
  FETCH_STATES_ERROR: 'FETCH_STATES_ERROR',
  NEWSLETTER_SUBSCRIPTION_SUCCESS: 'NEWSLETTER_SUBSCRIPTION_SUCCESS',
  NEWSLETTER_SUBSCRIPTION_ERROR: 'NEWSLETTER_SUBSCRIPTION_ERROR',
  ANALYTICS: 'ANALYTICS',

  // useFetch Hook
  FETCH: 'FETCH',
  FETCH_IN_PROGRESS: 'FETCH_IN_PROGRESS',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILED: 'FETCH_FAILED'
};
